<template>
    <div class="nevs-content">
        <NevsTabs class="supply-tabs" v-model="currentTab" :tabs="tabs"></NevsTabs>
        <NevsTab :model-value="currentTab" :value="1">
            <NevsCard>
                <NevsTextField :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="supplyStatesData.filters.name"></NevsTextField>
                <span style="float: right; margin-right: 10px;"><NevsButton @click="excelExportStates"><i class="fa-solid fa-file-excel"></i></NevsButton></span>
                <div style="clear: both;"></div>

                <table class="supply-table">
                    <thead>
                    <tr>
                        <td>{{ $LANG.Get('fields.name') }}</td>
                        <td colspan="2" style="text-align: right">{{ $LANG.Get('fields.quantity') }}</td>
                        <td colspan="2" style="text-align: right">{{ $LANG.Get('fields.averageAcquisitionPrice') }}</td>
                        <td colspan="2" style="text-align: right">{{ $LANG.Get('fields.totalValue') }}</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(supplyState, key) in supplyStatesData.records" :key="key" :class="{'supply-negative' : supplyState.quantity < 0}">
                        <td>{{ supplyState.ware_name_display }}</td>
                        <td style="width: 100px; text-align: right">{{ supplyState.quantity_display }}</td>
                        <td style="width: 60px; text-align: right">{{ supplyState.measurement_unit_display }}</td>
                        <td style="width: 150px; text-align: right">{{ supplyState.value_display }}</td>
                        <td style="width: 60px; text-align: right">EUR</td>
                        <td style="width: 150px; text-align: right">{{ supplyState.total_value_display }}</td>
                        <td style="width: 60px; text-align: right">EUR</td>
                    </tr>
                    </tbody>
                </table>
            </NevsCard>
        </NevsTab>
        <NevsTab :model-value="currentTab" :value="2">
            <NevsCard>
                <NevsTextField :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="supplyTrafficData.filters.name"></NevsTextField>
                <NevsDateField :label="$LANG.Get('labels.dateFrom') + ':'" :width="'300px'" v-model="supplyTrafficData.filters.date_from"></NevsDateField>
                <NevsDateField :label="$LANG.Get('labels.dateTo') + ':'" :width="'300px'" v-model="supplyTrafficData.filters.date_to"></NevsDateField>
                <span style="float: right; margin-right: 10px;"><NevsButton @click="excelExportTraffic"><i class="fa-solid fa-file-excel"></i></NevsButton></span>
                <div style="clear: both;"></div>
                <table class="supply-table">
                    <thead>
                    <tr>
                        <td style="width: 60px;">{{ $LANG.Get('fields.time') }}</td>
                        <td style="width: 60px;">{{ $LANG.Get('fields.type') }}</td>
                        <td style="width: 100px;">{{ $LANG.Get('fields.code') }}</td>
                        <td>{{ $LANG.Get('fields.name') }}</td>
                        <td colspan="2" style="text-align: right">{{ $LANG.Get('fields.quantity') }}</td>
                        <td colspan="2" style="text-align: right">{{ $LANG.Get('fields.averageAcquisitionPrice') }}</td>
                        <td colspan="2" style="text-align: right">{{ $LANG.Get('fields.totalValue') }}</td>
                        <td style="text-align: right">{{ $LANG.Get('fields.document') }}</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(supplyTransaction, key) in supplyTrafficData.records" :key="key" :class="{ 'supply-in' : supplyTransaction.type === 'in', 'supply-out' : supplyTransaction.type === 'out' }">
                        <td>{{ supplyTransaction.time_display }}</td>
                        <td>{{ supplyTransaction.type_display }}</td>
                        <td>{{ supplyTransaction.code }}</td>
                        <td>{{ supplyTransaction.name }}</td>
                        <td style="width: 100px; text-align: right">{{ supplyTransaction.quantity_display }}</td>
                        <td style="width: 60px; text-align: right">{{ supplyTransaction.measurement_unit }}</td>
                        <td style="width: 150px; text-align: right">{{ supplyTransaction.value_display }}</td>
                        <td style="width: 60px; text-align: right">EUR</td>
                        <td style="width: 150px; text-align: right">{{ supplyTransaction.total_value_display }}</td>
                        <td style="width: 60px; text-align: right">EUR</td>
                        <td style="width: 80px; text-align: right" @click="openLink(supplyTransaction.document_link)"><NevsButton><i class="fa-solid fa-file"></i> {{ supplyTransaction.document_name }}</NevsButton></td>
                    </tr>
                    </tbody>
                </table>
            </NevsCard>
        </NevsTab>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsTabs from "@/components/nevs/NevsTabs.vue";
import NevsTab from "@/components/nevs/NevsTab.vue";
import moment from "moment/moment";

export default {
    name: "ModuleSupplies",
    components: {NevsTab, NevsTabs, NevsDateField, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            currentTab: 1,
            supplyStatesData: {
                filters: {
                    name: ''
                },
                records: [],
                filterTimer: null
            },
            supplyTrafficData: {
                filters: {
                    name: '',
                    date_from: null,
                    date_to: null
                },
                records: [],
                filterTimer: null
            },
        }
    },
    computed: {
        tabs() {
            return [
                {value: 1, label: this.$LANG.Get('buttons.supplies')},
                {value: 2, label: this.$LANG.Get('buttons.traffic')}
            ];
        }
    },
    watch: {
        'currentTab': {
            handler() {
                if (this.currentTab === 1) {
                    this.reloadSupplyStates();
                }
            },
            deep: true
        },
        'supplyStatesData.filters.name': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadSupplyStates();
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        },
        'supplyTrafficData.filters.name': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadSupplyTraffic();
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        },
        'supplyTrafficData.filters.date_from': {
            handler() {
                if (this.supplyTrafficData.filters.date_from === null) return;
                this.reloadSupplyTraffic();
            },
            deep: true
        },
        'supplyTrafficData.filters.date_to': {
            handler() {
                if (this.supplyTrafficData.filters.date_to === null) return;
                this.reloadSupplyTraffic();
            },
            deep: true
        }
    },
    methods: {
        openLink(link) {
          window.open(link);
        },
        excelExportStates() {
            let vm = this;
            let request = {
                sort: {
                    field: 'ware_name',
                    descending: false
                },
                filters: this.supplyStatesData.filters,
                currentPage: 1,
                rowsPerPage: 0
            };
            this.$API.APICall('get', 'supply-states/excel', request, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        reloadSupplyStates() {
            let vm = this;
            let request = {
                sort: {
                    field: 'ware_name',
                    descending: false
                },
                filters: this.supplyStatesData.filters,
                currentPage: 1,
                rowsPerPage: 0
            };
            this.$API.APICall('get', 'supply-states', request, (data, success) => {
                if (success) {
                    vm.supplyStatesData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        excelExportTraffic() {
            let vm = this;
            let request = {
                filters: this.supplyTrafficData.filters
            };
            this.$API.APICall('get', 'supply-traffic/excel', request, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        reloadSupplyTraffic() {
            let vm = this;
            let request = {
                filters: this.supplyTrafficData.filters
            };
            this.$API.APICall('get', 'supply-traffic', request, (data, success) => {
                if (success) {
                    vm.supplyTrafficData.records = data;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        if (!this.$store.state.user.client.plus) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }
        this.$store.commit('selectMenu', 'catalog');
        this.$store.commit('selectSubMenu', 'supplies');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.catalog'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.supplies'),
                link: null
            }
        ]);
        this.supplyTrafficData.filters.date_from = moment().subtract(1, 'month').format('YYYY-MM-DD');
        this.supplyTrafficData.filters.date_to = moment().format('YYYY-MM-DD');
        this.$nextTick(()=>{
            this.reloadSupplyStates();
            this.reloadSupplyTraffic();
        });
    }
}
</script>

<style scoped>
.supply-tabs {
    margin-bottom: 10px;
}

.supply-popup-title {
    margin-left: 7px;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 20px;
}

.supply-table {
    margin-top: 20px;
    clear: both;
    font-size: 18px;
    width: 100%;
    border-collapse: collapse;
}

.supply-table tr:hover {
    background-color: lightgray;
}

.supply-table td {
    border-bottom: 1px solid grey;
    padding: 10px;
}

.supply-negative {
    color: red;
}

.supply-in {
    color: green;
}

.supply-out {
    color: red;
}


</style>